export {default} from './RolesListModel';
export {RolesListModelType} from './RolesListModel';



// WEBPACK FOOTER //
// ./src/models/RolesListModel/index.ts